export class FinancialObligationOptions {
    constructor(
        public studentDebt: boolean,
        public paymentAccountOverdraft: boolean,
        public mobilePhonePayment: boolean,
        public openEndedCredit: boolean,
        public creditCard: boolean,
        public privateLease: boolean,
        public personalLoan: boolean,
        public partnerAlimony: boolean,
        public noObligations: boolean
    ) {}
}

export enum FinancialObligationOption {
    OPTIONS,
    STUDENT_DEBT,
    PAYMENT_ACCOUNT_OVERDRAFT,
    MOBILE_PHONE_PAYMENT,
    OPEN_ENDED_CREDIT,
    CREDIT_CARD,
    PRIVATE_LEASE,
    PERSONAL_LOAN,
    PARTNER_ALIMONY,
    SUMMARY
}

export enum OptionQuestion {
    STUDENT_DEBT = 'studentDebt',
    PAYMENT_ACCOUNT_OVERDRAFT = 'paymentAccountOverdraft',
    MOBILE_PHONE_PAYMENT = 'mobilePhonePayment',
    OPEN_ENDED_CREDIT = 'openEndedCredit',
    CREDIT_CARD = 'creditCard',
    PRIVATE_LEASE = 'privateLease',
    PERSONAL_LOAN = 'personalLoan',
    PARTNER_ALIMONY = 'partnerAlimony'
}

export enum StudentDebtQuestion {
    MONTHLY_AMOUNT,
    SUMMARY
}

export enum PaymentAccountOverdraftQuestion {
    AMOUNT,
    TIP,
    SUMMARY
}

export enum MobilePhonePaymentQuestion {
    AMOUNT,
    SUMMARY
}

export enum OpenEndedCreditQuestion {
    AMOUNT,
    SUMMARY
}

export enum CreditCardQuestion {
    SEVERAL_INSTALLMENTS,
    AMOUNT,
    TIP,
    SUMMARY
}

export enum PrivateLeaseQuestion {
    AMOUNT,
    MONTHS,
    SUMMARY
}

export enum PersonalLoanQuestion {
    MONTHLY_PAYMENT,
    TOTAL_AMOUNT,
    SUMMARY
}

export enum PartnerAlimonyQuestion {
    AMOUNT,
    SUMMARY
}
